import {KeyValueTable} from '../KeyValueTable'
import {Media} from '../Media'

import type {DataSheetItemProps} from '../DataSheetItem'
import type {KeyValueTableProps} from '../KeyValueTable'

interface DrawerContentProps extends Omit<DataSheetItemProps, 'buttonLabel' | 'onButtonClick'> {
  tableData?: {
    sectionName: string | null
    data: KeyValueTableProps['data']
  }[]
}

export const DataSheetDrawerContent = (props: DrawerContentProps) => {
  const {title, mediaProps, description, additional, tableData} = props

  return (
    <>
      <h2 className={'mb-block-medium text-h2'}>{title}</h2>
      <Media
        {...mediaProps}
        aspectRatio={'16/9'}
      />
      <p className={'pt-spacing-16 text-p2'}>{description}</p>
      <p className={'text-p3'}>{additional}</p>
      {/* BlockVehicleDataTable */}
      {tableData?.map(({sectionName, data}, index) => (
        <div key={`${index}_${sectionName}`}>
          <h4 className={'pb-spacing-24 pt-spacing-48 text-h4'}>{sectionName}</h4>
          <KeyValueTable
            alignValue={'START'}
            data={data}
          />
        </div>
      ))}
    </>
  )
}